// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subscribe-oracle-dialog.common-dialog[data-v-3c79a01c] .el-dialog{width:var(--common-dialog-width)}.subscribe-oracle-dialog.common-dialog .el-form[data-v-3c79a01c]{margin-right:var(--common-dialog-form-margin-right)}", ""]);
// Exports
module.exports = exports;
